// Juju Mood başlangıç tasarımlarındaki ürünler — Merchant Center 22 Eki 2026 anlık görüntüsü
// (fiyatlar stüdyoda güncellenebilir). Üreteç: glowytics-backend/var/juju_email/products.py
const PR = {
 "MINI_SQ": {
  "title": "Mini Square Bileklik",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/mini-square-bileklik",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/files/MiniSquareBileklik3_e0595c50-4522-48a8-8619-fd4babb62267.jpg?v=1761046040",
  "price": 2116.0,
  "listPrice": 2645.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/debe9fc8ec14c0b179c3.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/0fa95e04588e2031ad04.jpg"
 },
 "T_MINI_SQ": {
  "title": "Taşlı Mini Square Bileklik",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/mini-square-bracelet-with-stones",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/products/6796257-img_1745.webp?v=1764592515",
  "price": 2596.0,
  "listPrice": 3245.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/5bde1d9f9a2462fc73c7.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/6f853063c3ff658c8933.jpg"
 },
 "T_ROPE": {
  "title": "Taşlı Rope Bileklik",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/stone-rope-bileklik",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/products/9558049-img_1836.webp?v=1764613277",
  "price": 1156.0,
  "listPrice": 1445.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/3400f3efdac6ac3f35f5.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/b0106145eb0ca28638fd.jpg"
 },
 "ROUND": {
  "title": "Round Bileklik",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/round-bileklik",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/products/1613316136559-ccb307.webp?v=1683888231",
  "price": 916.0,
  "listPrice": 1145.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/bbca3ae3ee55c37bed47.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/5f163e424f6c7906e92a.jpg"
 },
 "HB_B": {
  "title": "Heartbeat Bileklik",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/heart-beat-bileklik",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/files/8A9A6819.jpg?v=1764592596",
  "price": 4356.0,
  "listPrice": 5445.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/158ac4ed97b8acbd3540.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/feb84659cd790ab945ea.jpg"
 },
 "HB_Y": {
  "title": "Heartbeat Yüzük",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/heart-beat-yuzuk",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/products/2380562-9.webp?v=1681903912",
  "price": 1956.0,
  "listPrice": 2445.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/54fe0e6fb66ac0fbad83.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/acf96d4b85813c480e1b.jpg"
 },
 "HB_K": {
  "title": "Heartbeat Küpe",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/heart-beat-kupe",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/products/1613402822967-cce-834-2.webp?v=1769431295",
  "price": 2116.0,
  "listPrice": 2645.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/2a1f831e27e4b3c4679f.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/e29aadb96665ef353c2f.jpg"
 },
 "BEE": {
  "title": "Bee Küpe",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/bee-kupe",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/products/1625009962083-CCE-999_d7a62ac8-1fc2-4166-b028-0cb60ae060b5.webp?v=1680511176",
  "price": 996.0,
  "listPrice": 1245.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/2e73d43c31c37a97f5d6.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/d9a12d55ea0c2bffe1f4.jpg"
 },
 "CYL": {
  "title": "Angled Cylinder Kolye",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/angled-cylinder-kolye",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/products/1613388783770-CCN-903_20yan.webp?v=1741099852",
  "price": 5956.0,
  "listPrice": 7445.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/a92e01869a6ef1f075c9.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/0c5e0f3fc6f64dd23ea8.jpg"
 },
 "T_TRI": {
  "title": "Taşlı Triangle Küpe",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/triangle-earrings-with-stones",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/products/1625010379053-CCE-1047.webp?v=1680511179",
  "price": 1956.0,
  "listPrice": 2445.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/a24fbf4a6b42ab1f43e5.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/9bd5b7e6d524376d339b.jpg"
 },
 "ISIM_B": {
  "title": "İsim Bileklik",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/personalized-bileklik",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/files/CAN.png?v=1787322101",
  "price": 4356.0,
  "listPrice": 5445.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/ff6c0c6cf28c52a21f92.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/a23c11642301e973fc21.jpg"
 },
 "ISIM_IP": {
  "title": "Taşlı ve Mineli İsim İp Bileklik",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/tasli-ve-mineli-i%CC%87sim-i%CC%87p-bileklik",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/files/CCI-2287.jpg?v=1769495026",
  "price": 996.0,
  "listPrice": 1245.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/0003b1b3c9f50c54159c.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/02d4f7ec72c843eb0cf1.jpg"
 },
 "ISIM_K": {
  "title": "Mineli İsim Kolye",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/tasli-isim-kolye",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/files/5D0A9274.jpg?v=1745581133",
  "price": 4520.0,
  "listPrice": 5650.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/6c8413394edbad9a678e.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/7057e8f0c73df722255d.jpg"
 },
 "ISIM_TK": {
  "title": "Taşlı ve Mineli İsim Kolye",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/tasli-ve-mineli-isim-kolye",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/files/5D0A9282_7b836cfe-f900-48e4-9ca7-729e3fe7957e.jpg?v=1745588266",
  "price": 6756.0,
  "listPrice": 8445.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/fed6f2e683e70b24d4d6.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/cf21f912451eca7e42d5.jpg"
 },
 "LUC_K": {
  "title": "Lucien Kolye",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/lucien-kolye",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/files/2398_1.jpg?v=1785146562",
  "price": 5956.0,
  "listPrice": 7445.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/85ff6ce24977bee9b211.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/759bd063ddb0e3f2064d.jpg"
 },
 "LUC_B": {
  "title": "Lucien Bileklik",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/lucien-bileklik",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/files/Gemini_Generated_Image_lvoi9klvoi9klvoi.png?v=1785140196",
  "price": 2116.0,
  "listPrice": 2645.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/df228cef85d8176e63b1.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/79fa3dbb0342c87f1f45.jpg"
 },
 "LUC_H": {
  "title": "Lucien Halhal",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/lucien-halhal",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/files/2397.jpg?v=1785143144",
  "price": 2276.0,
  "listPrice": 2845.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/51de2d13ca4aeafdd6f3.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/5d109286dcf3c45966c9.jpg"
 },
 "SOR_K": {
  "title": "Soren Kolye",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/soren-kolye",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/files/2395_1.jpg?v=1784888197",
  "price": 5956.0,
  "listPrice": 7445.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/f05275bde0e734cd9357.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/e4e2e5380be85695a2bc.jpg"
 },
 "SOR_B": {
  "title": "Soren Bileklik",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/soren-bileklik",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/files/2394.jpg?v=1784884648",
  "price": 2116.0,
  "listPrice": 2645.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/6ba4c02a5103da969314.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/f8fbdac238be19665f62.jpg"
 },
 "SIERRA": {
  "title": "Sierra Bileklik",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/sierra-bileklik",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/files/2392_1.jpg?v=1784810220",
  "price": 4996.0,
  "listPrice": 6245.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/28b47b9aacc363314256.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/59445672cdde717e2294.jpg"
 },
 "SLATE": {
  "title": "Slate Bileklik",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/sentry-bileklik-1",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/files/2391_1.jpg?v=1784803423",
  "price": 4996.0,
  "listPrice": 6245.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/c754160503bb149c0858.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/6bf3b85586dae6c33f0c.jpg"
 },
 "SENTRY": {
  "title": "Sentry Bileklik",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/sentry-bileklik",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/files/2390_1.jpg?v=1784795937",
  "price": 4356.0,
  "listPrice": 5445.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/b0a0ed9aeb3f4a339b5e.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/d2cc29d377da875e7317.jpg"
 },
 "ARDENT": {
  "title": "Ardent Bileklik",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/ardent-bileklik",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/files/2393_1.jpg?v=1784814711",
  "price": 3556.0,
  "listPrice": 4445.0,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/0178d06e651aaeac52a7.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/9cf3249402dcdeec2044.jpg"
 },
 "GIFT": {
  "title": "Hediye Kartı",
  "color": "",
  "brand": "",
  "url": "https://jujumood.com/products/5000-tl-hediye-ceki",
  "image": "https://cdn.shopify.com/s/files/1/0622/6519/6726/files/5000.jpg?v=1745934847",
  "price": null,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/b66a57ea4b0f69ae2918.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/a431e51f-1154-45f9-9b0b-b07f0f39a80b/f7720cbfbd42c5e71bf2.jpg"
 }
};

export default PR;
